import React from 'react';

function getStrength(pw) {
  if (!pw) return { score: 0, label: '', color: '', textColor: '' };
  let score = 0;
  if (pw.length >= 6) score++;
  if (pw.length >= 10) score++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^a-zA-Z0-9]/.test(pw)) score++;

  if (score <= 1) return { score, label: 'Weak', color: 'bg-red-500', textColor: 'text-red-500' };
  if (score <= 2) return { score, label: 'Fair', color: 'bg-amber-500', textColor: 'text-amber-500' };
  if (score <= 3) return { score, label: 'Good', color: 'bg-blue-500', textColor: 'text-blue-500' };
  return { score, label: 'Strong', color: 'bg-emerald-500', textColor: 'text-emerald-500' };
}

export function PasswordStrength({ password }) {
  const { score, label, color, textColor } = getStrength(password);
  if (!password) return null;

  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1 mb-1">
        {[1, 2, 3, 4, 5].map(i => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors ${i <= score ? color : 'bg-slate-200'}`}
          />
        ))}
      </div>
      <p className={`text-[10px] font-medium ${textColor}`}>{label}</p>
    </div>
  );
}
